export default [
  {
    path: "/estimates",
    name: "Estimates",
    component: () => import("@/views/3pl/Billings/Estimates/index.vue")
  },
  {
    path: "/new-estimate",
    name: "NewEstimate",
    component: () => import("@/views/3pl/Billings/Estimates/NewEstimate.vue")
  },
  {
    path:"/billing-and-payments",
    name:"BillingAndPayments",
    component: () => import("@/views/3pl/Billings/Overview/index.vue")
  },
  {
    path:"/billing-and-payments/payments",
    name:"BillingPayments",
    component: () => import("@/views/3pl/Billings/Payments/index.vue")
  }
];
 